


export const AccountStatus = [ '0-Invalid', '1-Invalid', '2-Not Active', '3-Invalid', '4-Active'];


export const PricingMethods = ['0-Free', '1-Ent(old)', '2-Plus', '3-Ent(new)'];

export const RecurringModes = ['0-Unsubscribed', '1-CC', '2-PP', '3-Manual', '4-Free', '5-Unsubscribing'];

export const RecurringPaymentStatus = [ 'pending', 'po', 'paid', 'unpaid' ];
